import moment from "jalali-moment";
import React from "react";
import profile from "../../assets/img/temp/profile.png";

const CommentReply = ({info}) => {
  return (
    <div className="CommentReply mt-[20px]">
      <div className="flex items-center">
        <img src={profile} />
        <div>
        <p className="font-[500] text-[14px] text-[#292D32] ">{info.username}</p>
        <p className="font-[400] text-[12px] text-[#797D82] ">منتشر شده در  {info.created_at} </p>
        </div>
      </div>
      <p className="font-[400] text-[14px] text-[#797D82] mt-[10px] ">
       {info.body}
      </p>
    </div>
  );
};

export default CommentReply;
